import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { RestApiService } from '../../shared/services/rest-api.service';
import { JustificationService } from '../../shared/services/justification.service';
import { DailyClockStatus } from '../../shared/models/daily-clock-status';
import { DxDataGridModule, DxButtonModule, DxValidatorModule } from 'devextreme-angular';
import { ToolbarService } from 'src/app/shared/services/toolbar.service';


/* ../../ services/justification.service */
@Component({
    selector: 'app-clock-status-table',
    imports: [
    DxDataGridModule,
    DxButtonModule,
    DxValidatorModule
],
    templateUrl: './clock-status-table.component.html',
    styleUrl: './clock-status-table.component.scss'
})
export class ClockStatusTableComponent implements OnInit {
  dailyClockStatuses: DailyClockStatus[] = [];
  tenantId: number | undefined;
  workerNumber: string | undefined; 

  constructor(private restApiService: RestApiService,
              private justificationService: JustificationService,
              private toolbar: ToolbarService,
              private router: Router) {
    this.tenantId = Number(localStorage.getItem("tenantId"));
    this.workerNumber = localStorage.getItem("user")?.substring(3);
  }

  ngOnInit(): void {
    this.loadData();

    this.toolbar.PlusVisibleChanged(false);
    this.toolbar.MenuVisibleChanged(false);

    this.toolbar.TitleChanged("Cartellino");

    this.toolbar.CancelVisibleChanged(false);
    this.toolbar.ForwardVisibleChanged(false);
  }

  loadData(): void {
    this.restApiService.getDailyClocks(this.tenantId!, this.workerNumber!).subscribe(data => {
      this.dailyClockStatuses = data;
    });
  }
  onClick(rowData: any) {
    const day = Number(rowData.date.substring(0, 2));
    const year = Math.floor(rowData.monthYearNumber) / 100;
    const month = Number(rowData.monthYearNumber) % 100 - 1;

    const date = new Date(year, month, day);
    const justification = rowData.justification || '';
    const note = rowData.note || '';

    // Imposta i dati nel servizio per passarli al form di giustifica
    this.justificationService.setJustification(justification);
    this.justificationService.setNote(note);
    this.justificationService.setDate(date);
    this.router.navigate(['/justification']);
  }
  onCellPrepared(e: any): void {
    //imposto il colore della data
    if (e.rowType === 'data' && e.column.dataField === 'date') {
      //rosso -> festivo
      //arancione -> sabato
      //lavorativo -> nero
      if (e.data.isHoliday) {
        e.cellElement.style.color = 'red';
      } else if (e.data.isSaturday) {
        e.cellElement.style.color = 'orange';
      } else {
        e.cellElement.style.color = '';
      }
    }
    // Imposto il colore di sfondo per la colonna "clocks"
    if (e.rowType === 'data' && e.column.dataField === 'clocks') {
      // Timbratura completa: verde
      if (e.data.isComplete) {
        e.cellElement.style.backgroundColor = 'green';
        e.cellElement.style.color = 'white';

        // Giorno lavorativo con timbratura incompleta: rosso
      } else if (!e.data.isComplete && !(e.data.isHoliday || e.data.isSaturday)) {
        e.cellElement.style.backgroundColor = 'red';
        e.cellElement.style.color = 'white';

        // Weekend/festivo con timbratura incompleta
      } else if (!e.data.isComplete && (e.data.isHoliday || e.data.isSaturday)) {
        // Nessuna timbratura: bianco
        if (e.data.clocks.length === 0) {
          e.cellElement.style.backgroundColor = 'white';
          e.cellElement.style.color = 'black';
        } else {
          // Almeno una timbratura: rosso
          e.cellElement.style.backgroundColor = 'red'; 
          e.cellElement.style.color = 'white';
        }
      }
    }
  }


  getMonthYearString(data: any): string {
    if (data.data.items?.length > 0) {
      // Se il gruppo è aperto, prendi il valore dal primo elemento
      return data.data.items[0].monthYearString;
    }
    // Se il gruppo è chiuso, usa il numero per ricavare la stringa
    return this.mapMonthYearNumberToString(data.value);
  }
  //metodo per ricavare la stringa da visualizzare partendo dalla valore intero
  mapMonthYearNumberToString(monthYearNumber: number): string {
    const year = Math.floor(monthYearNumber / 100);
    const month = monthYearNumber % 100;

    const mesi = [
      'gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno',
      'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'
    ];

    return `${mesi[month - 1]} ${year}`;
  }
}
